module.exports = __webpack_public_path__ + "static/media/retirement-object-2-1-0.9214c3d8.png";